































































































































































































































































































































import { Component, Prop, Vue, Mixins } from 'vue-property-decorator'
import UserApi from '@/api/user'
import TaskApi from '@/api/task'
import cloneDeep from 'lodash/cloneDeep'
import PageLayout from '@/components/page/PageLayout.vue'
import listMixins from '@/mixins/list'
import { userName } from '@/utils/regExp'
import { nameLength } from '@/config/global'

@Component({
	name: 'UserList',
	components: {
		PageLayout,
	},
})
export default class UsersList extends Mixins(listMixins) {
	private visible: boolean = false

	private addForm: any = {}
	private modForm: any = {}

	private companyOptions: any = []

	private userName: any = userName
	private nameLength: any = nameLength

	// 表头
	private columns: any = [
		{
			title: '序号',
			dataIndex: 'order',
			align: 'center',
			width: 60,
			scopedSlots: { customRender: 'order' },
		},
		{
			title: '编号',
			align: 'center',
			dataIndex: 'employeeId',
		},
		{
			title: '用户名',
			align: 'center',
			dataIndex: 'username',
		},
		{
			title: '姓名',
			align: 'center',
			dataIndex: 'name',
		},
		{
			title: '电话',
			align: 'center',
			dataIndex: 'mobile',
		},
		{
			title: '邮箱',
			align: 'center',
			dataIndex: 'email',
		},
		{
			title: '地区',
			align: 'center',
			dataIndex: 'location',
		},
		{
			title: '公司',
			align: 'center',
			dataIndex: 'companyName',
		},
		{
			title: '权限',
			align: 'center',
			dataIndex: 'permissionName',
		},
		{
			title: '账号状态',
			align: 'center',
			dataIndex: 'employeeStatus',
			scopedSlots: { customRender: 'employeeStatus' },
		},
	]

	private rolesOptions: any[] = []
	private data: any[] = []
	private first: boolean = true
	private searchRoles: any = []
	private title: any = '新增用户'

	private addLoading: boolean = false
	private modLoading: boolean = false

	public async created() {
		this.addForm = this.$form.createForm(this)
		this.modForm = this.$form.createForm(this)
		this.$store.dispatch('setting/initPartnerAndCompany').then((res: any) => {
			this.setCompany()
		})
		this.$store.dispatch('setting/initAreas')
	}

	public activated() {
		this.getList()
		this.getRoles()
	}

	private get isUpdate() {
		return !!this.selected[0]
	}

	public getList() {
		const form = this.getSearchValues()
		return UserApi.getUserList(form).then((data: any) => {
			this.data = data.data.retList
			this.total = data.data.count
			this.resetSelected()
		})
	}

	private doAdd() {
		this.addForm.validateFields((err: any, values: any) => {
			if (!err) {
				this.addLoading = true
				values = cloneDeep(values)
				values.roleCodes = [values.roleCodes]
				values.companyId = values.companyId.value
				const selected = this.selected[0]
				let p: any = ''
				if (selected) {
					values.employeeId = selected.employeeId
					p = UserApi.updateUser(values).then((res: any) => {
						this.$message.success('更新成功')
						this.visible = false
						this.getList()
					})
				} else {
					p = UserApi.addUser(values).then((res: any) => {
						if (res.data) {
							this.$success({
								title: '提示',
								content: res.data,
								okText: '确定',
							})
						} else {
							this.$message.success('添加用户成功')
						}
						this.visible = false
						this.resetPage()
						this.getList()
					})
				}
				p.finally(() => {
					this.addLoading = false
				})
			}
		})
	}

	private get areas() {
		const areas = cloneDeep(this.$store.state.setting.areas)
		for (const item of areas) {
			item.isLeaf = true
		}
		return [
			{
				isLeaf: true,
				key: '000000',
				title: '全国',
				value: '000000',
			},
		].concat(areas)
	}

	private modifyInfo() {
		if (this.checkSelected()) {
			this.title = '修改用户'
			const selected = this.selected[0]
			this.first = true
			this.rolesOptions = []
			this.visible = true
			this.addForm.resetFields()
			this.$nextTick(() => {
				this.addForm.setFieldsValue({
					userName: selected.username,
					name: selected.name,
					mobile: selected.mobile,
					email: selected.email,
					companyId: {
						value: selected.companyId + '',
						label: selected.companyName,
					},
				})
				UserApi.getRoles({
					companyId: selected.companyId,
					filterbyType: 1,
				}).then((res: any) => {
					this.rolesOptions = res.data
					this.addForm.setFieldsValue({
						roleCodes: selected.permissionCode,
					})
				})
			})
		}
	}

	private getRoles() {
		UserApi.getRoles({
			filterbyType: 0,
		}).then((res: any) => {
			this.searchRoles = res.data.map((item: any) => {
				return {
					key: item.code,
					value: item.name,
				}
			})
		})
	}

	private onCompanyChange(val: any) {
		this.rolesOptions = []
		this.addForm.setFieldsValue({
			roleCodes: undefined,
		})
		if (!val) {
			return
		}
		UserApi.getRoles({
			companyId: val.value,
			filterbyType: 1,
		}).then((res: any) => {
			this.rolesOptions = res.data
		})
	}

	private resetPwd() {
		if (this.checkSelected()) {
			const selected = this.selected[0]
			this.$confirm({
				title: '提示',
				content: `确认将该用户密码重置为${this.$store.state.setting.INITPWD}吗 ?`,
				onOk: () => {
					return UserApi.resetPwd(selected.username).then((res: any) => {
						this.$message.success('重置成功')
						this.getList()
					})
				},
			})
		}
	}

	private enable() {
		if (this.checkSelected()) {
			const selected = this.selected[0]
			this.$confirm({
				title: '提示',
				content: '确认启用吗 ?',
				onOk: () => {
					const form = {
						userId: selected.employeeId,
						enable: 1,
					}
					return UserApi.changeAccountStatus(form).then((res: any) => {
						this.$message.success('启用成功')
						this.getList()
					})
				},
			})
		}
	}

	private disable() {
		if (this.checkSelected()) {
			const selected = this.selected[0]
			this.$confirm({
				title: '提示',
				content: '确认停用吗 ?',
				onOk: () => {
					const form = {
						userId: selected.employeeId,
						enable: 0,
					}
					return UserApi.changeAccountStatus(form).then((res: any) => {
						this.$message.success('停用成功')
						this.getList()
					})
				},
			})
		}
	}

	private checkSelected() {
		if (!this.selected.length) {
			this.$message.error('请选择用户')
			return false
		}
		return true
	}

	public setCompany() {
		this.companyResult = this.$store.state.setting.partnerAndCompanyTree
	}

	private addNewUser() {
		this.resetSelected()
		this.title = '新增用户'
		this.addForm.resetFields()
		this.rolesOptions = []
		this.visible = true
	}
}
